import { ButtonBase, styled } from '@mui/material'

export const StyledButton = styled(ButtonBase)(({ theme }) => {
  return {
    height: 39,
    textTransform: 'none',
    padding: theme.spacing(1),
  }
})
